module.exports = __webpack_public_path__ + "static/media/matilde-special-crown-happy.e1510466.png";